import { useLvgOrderManager, useLvgLiveOrdersAmount } from 'hooks/games/lvg/useYourBidsOrders'
import { CashOutAllCSS } from './CashOutAllCSS.styled'
import { currencyFormatter } from 'utils'

export const CashOutAll = () => {
  const { liveOrdersAmount } = useLvgLiveOrdersAmount()
  const { closeAllOrders } = useLvgOrderManager()

  return (
    <CashOutAllCSS>
      <button
        className={`cashout_all ${
          liveOrdersAmount?.potentialPnl > 0
            ? 'profit'
            : liveOrdersAmount?.potentialPnl < 0
            ? 'loss'
            : liveOrdersAmount?.potentialAmount > 0
            ? 'neutral'
            : 'disabled'
        }`}
        onClick={closeAllOrders}
      >
        Cash out all
        <div className='pandl_cashoutall_ind'>
          <span>{currencyFormatter(liveOrdersAmount?.potentialPnl)}</span>
        </div>
      </button>
    </CashOutAllCSS>
  )
}
